// extracted by mini-css-extract-plugin
export var himsAboutsSection = "sectionTitle-module--himsAboutsSection--1555c";
export var mix_heading = "sectionTitle-module--mix_heading--69e2f";
export var mix_heading_Root = "sectionTitle-module--mix_heading_Root--7ba59";
export var mix_heading_wrap = "sectionTitle-module--mix_heading_wrap--6c1d5";
export var remove = "sectionTitle-module--remove--5d7a9";
export var small_text_span = "sectionTitle-module--small_text_span--8751f";
export var viewAllLink = "sectionTitle-module--viewAllLink--fb4ea";